export enum RecurrenceStatus{
    Active = 'ACTIVE',
    Expired = 'EXPIRED',
    Deleted = 'DELETED'
}

export enum RecurrenceStatusLabel{
    Active = 'LBL.ACTIVE',
    Expired = 'LBL.EXPIRED',
    Deleted = 'LBL.DELETED'
}
